import firebase from 'firebase/app';
import 'firebase/firestore';
import { correoContactoHtml, correoContactoTexto } from './correoContacto';

const config = {
    apiKey: process.env.REACT_APP_CONFIGFIREBASE_API_KEY,
    authDomain: "reditmextrescero.firebaseapp.com",
    databaseURL: "https://reditmextrescero.firebaseio.com",
    projectId: "reditmextrescero",
    storageBucket: "reditmextrescero.appspot.com",
    messagingSenderId: "104316742204",
    appId: "1:104316742204:web:158209a70f4669e0d5f139",
    measurementId: "G-NZ3WBBB63T"
}
const configBluePing = {
    apiKey: process.env.REACT_APP_CONFIGBLUEPING_API_KEY,
    authDomain: "bluepingdashboard.firebaseapp.com",
    projectId: "bluepingdashboard",
    storageBucket: "bluepingdashboard.appspot.com",
    messagingSenderId: "635020680775",
    appId: "1:635020680775:web:d00db3a0ad4dd75c525b62",
    measurementId: "G-41H077C5DN"
}

firebase.initializeApp(config);
var secondaryApp = firebase.initializeApp(configBluePing, "AuthenticateSecondary")
export const firestoreBluePing = secondaryApp.firestore()

export const getCoberturasRef = () => {
    const coberturasRef = firestore.collection('comunidades')
    return coberturasRef;
}
export const getMunicipiosZonasRef = (idEstado) => {
    const municipiosZonasRef = firestore.collection('comunidades').doc(idEstado).collection('municipiozona')
    if (municipiosZonasRef) {
        return municipiosZonasRef;
    } else {
        return false
    }
}
export const getComunidadesRef = (idEstado, idMunicipio) => {
    const comunidadRef = firestore.collection('comunidades').doc(idEstado).collection('municipiozona').doc(idMunicipio).collection('zonas').orderBy("nombre", "asc")
    if (comunidadRef) {
        return comunidadRef;
    } else {
        return false
    }
}
export const getComunidadesDisponiblesRef = (idEstado, idMunicipio) => {
    const comunidadRef = firestore.collection('comunidades').doc(idEstado).collection('municipiozona').doc(idMunicipio).collection('zonas').where("disponible", "!=", false).orderBy("disponible", "asc").orderBy("nombre", "asc")
    if (comunidadRef) {
        return comunidadRef;
    } else {
        return false
    }
}

export const firestore = firebase.firestore();
export default firebase;


//BLUE PING

// Encola el correo en Firestore (colección que procesa la extensión de envío de correos de BluePing)
export const sendBlueMail = async ({ nombre, email, telefono, asunto, mensaje }) => {
    var successError = { success: null, success_message: null, success_code: null, error: null, error_message: null, error_code: null, response: null}
    const leido = false;
    const createdAt = new Date()
    const datos = { nombre, email, telefono, asunto, mensaje, fecha: createdAt }
    await firestoreBluePing.collection('clientsBluePing').doc("pRNV5AvyjEsxHfjqkxzh").collection("legos").doc("blueMail").collection("data")
        .add({ 
            to: ["isalvadorp@hotmail.com","luisarturozerep@gmail.com"],
            replyTo: email,
            message: {
                subject: "[REDITMEX.COM] Contacto: " + asunto,
                html: correoContactoHtml(datos),
                text: correoContactoTexto(datos)
            },
            contactMensaje: mensaje,
            leido,
            createdAt
        }).then((mail)=>{
            successError.success= true;
            successError.success_message="Correo enviado";
            successError.success_code=200;
            successError.response = mail;
            return successError
        }).catch((error)=>{
            console.log(error)
            successError.error= true;
            successError.error_message=error.message;
            successError.error_code=error.code;
            successError.response = error;
            return successError
        })
    return successError
}